export const AnimationDelay = 200;
